<app-topnav></app-topnav>

<!-- ======= Header ======= -->
<header id="header" class="fixed-top d-none d-sm-block">
    <nav class="navbar nav-menu navbar-expand-lg">
        <div class="collapse navbar-collapse justify-content-center" id="main_nav">

            <ul class="navbar-nav ">
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> sports </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-cricket.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(4)">
                                            <h5 class="m-0">cricket</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-football.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(1)">
                                            <h5 class="m-0">football</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-tennis.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(2)">
                                            <h5 class="m-0">tennis</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> teenpatti </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-teenpatti.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(99999)">
                                            <h5 class="m-0">teenpatti</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> casino </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-casino.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(99995)">
                                            <h5 class="m-0">Casino</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item dropdown has-megamenu">
                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" data-toggle="dropdown"> special market
                    </a>
                    <div class="dropdown-menu megamenu">
                        <div class="container-fluid d-block">
                            <div class="row justify-content-center">
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-binary.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(99990)">
                                            <h5 class="m-0">binary</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="media align-items-center text-uppercase">
                                        <img class="align-self-center mr-2"
                                            src="http://speedcdn.io/assets/kesar-client/landing/menu-election.png">
                                        <a href="javascript:void(0);" (click)="confirmSport(2378961)">
                                            <h5 class="m-0">election</h5>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div> <!-- navbar-collapse.// -->
    </nav>
</header><!-- End Header -->

<!-- ======= Hero Section ======= -->
<section id="slider" class="d-flex align-items-center">
    <div id="carouselExampleInterval" class="carousel slide slider-div" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselExampleInterval" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleInterval" data-slide-to="1"></li>
            <li data-target="#carouselExampleInterval" data-slide-to="2"></li>
            <li data-target="#carouselExampleInterval" data-slide-to="3"></li>
            <li data-target="#carouselExampleInterval" data-slide-to="4"></li>
            <li data-target="#carouselExampleInterval" data-slide-to="5"></li>
        </ol>
        <div class="carousel-inner">
            <!-- <div class="carousel-item active" data-interval="10000">
                <img class="img-fluid" src="assets/images/position/c688fe9a-dd84-450d-a79c-d3eb3de97e84.jpg">
            </div>
            <div class="carousel-item" data-interval="2000">
                <img class="img-fluid" src="assets/images/position/936a369c-a297-49c8-9be5-e3c79343d63c.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="assets/images/position/1ff20184-aed0-40bc-a63a-d613423f443d.jpg">
            </div> -->
            <div class="carousel-item active">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner1.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner2.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner3.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner4.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner5.jpg">
            </div>
            <div class="carousel-item">
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/banner6.jpg">
            </div>
        </div>
    </div>
</section><!-- End Hero -->

<main id="main" class="main-content">
    
    <app-upcoming></app-upcoming>

    <!-- fastest-oods -->
    <section id="fastest-oods" class="py-4">
        <div class="container">
            <h2 class="section-title">The Best Online Cricket Id Provider <small>Get Your online cricket ID with Faster withdrawal Within 5 Minutes. 100% Safe & Trusted Online Cricket & Casino ID Provider With 24×7 Service and Support.</small></h2>
            <div class="row">
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" [routerLink]="['/exchange_sports', 4]">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/cricket_pic.jpg">
                            <h3>cricket</h3>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" [routerLink]="['/exchange_sports', 1]">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/football_pic.jpg">
                            <h3>football</h3>
                        </div>                        
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="fds-div">
                        <div class="fds-img" [routerLink]="['/exchange_sports', 2]">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/tennis_pic.jpg">
                            <h3>tennis</h3>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <!-- fastest-oods -->

    <!-- for mobile view -->
    <!-- <div id="me-slider" class="carousel slide py-2 me-slider" data-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            22 events
                        </div>
                        <div class="col-4">
                            cricket
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>new zealand</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>pakistan</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-item">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            220 events
                        </div>
                        <div class="col-4">
                            casino
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>india</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>aus</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-item">
                <div class="container">
                    <div class="row text-center mx-0 bg-danger">
                        <div class="col-4">
                            100 events
                        </div>
                        <div class="col-4">
                            football
                        </div>
                        <div class="col-4">
                            7 jan
                        </div>
                    </div>
                    <div class="row text-center mx-0 bg-white">
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <img class="img-fluid" src="assets/images/big/ec.png">
                                <h5>new zealand</h5>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-center">
                            <span class="me-info">567/6 : 564/10</span>
                        </div>
                        <div class="col-4 px-0 text-center d-inline-flex mx-auto">
                            <div class="media mx-auto">
                                <h5>pakistan</h5>
                                <img class="img-fluid" src="assets/images/big/ec.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- for mobile view -->

    <!-- for other white label -->
    <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <div class="row">
                <div class="col-lg-2 col-6" (click)="confirmSport(4)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_1.jpg">
                        <p>CRICKET</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(1)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_3.jpg">
                        <p>FOOTBALL</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(2)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_2.jpg">
                        <p>TENNIS</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(99999)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_6.jpg">
                        <p>TEEN PATTI</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(99995)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_7.jpg">
                        <p>CASINO</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(0)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_8.jpg">
                        <p>SLOT</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(99990)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_4.jpg">
                        <p>BINARY</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmSport(2378961)">
                    <div class="small-box position-relative">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/m_sport_5.jpg">
                        <p>ELECTION</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- for other white label -->

    <!-- for mobile view -->
    <!-- <section id="tabs-mobile" class="m-custom-tabs pb-2">
        <div class="row">
            <div class="col-4">
                <div class="nav flex-column nav-pills text-center" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <a class="nav-link active" id="v-sport-tab" data-toggle="pill" href="#sport-tab" role="tab"
                        aria-controls="sport-tab" aria-selected="true">
                        <img class="img-fluid" src="assets/images/icon/png/sport-sidebar.png">
                        sports
                    </a>

                    <a class="nav-link" id="v-teenpatti-tab" data-toggle="pill" href="#teenpatti-tab" role="tab"
                        aria-controls="teenpatti-tab" aria-selected="true">
                        <img class="img-fluid" src="assets/images/icon/png/teenpatti-unactive.png">
                        teenpatti
                    </a>

                    <a class="nav-link" id="v-casino-tab" data-toggle="pill" href="#casino-tab" role="tab"
                        aria-controls="casino-tab" aria-selected="true">
                        <img class="img-fluid" src="assets/images/icon/png/live-casino-sidebar.png">
                        casino
                    </a>

                    <a class="nav-link" id="v-sp-tab" data-toggle="pill" href="#sp-tab" role="tab"
                        aria-controls="sp-tab" aria-selected="true">
                        <img class="img-fluid" src="assets/images/icon/png/special-event-sidebar.png">
                        special market
                    </a>
                </div>
            </div>
            <div class="col-8">
                <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="sport-tab" role="tabpanel" aria-labelledby="v-sport-tab">
                        <div class="tab-img-div" (click)="confirmSport(4)">
                            <img class="img-fluid" src="assets/images/image/m_menu-cricket.svg">
                            <p>cricket</p>
                        </div>
                        <div class="tab-img-div" (click)="confirmSport(1)">
                            <img class="img-fluid" src="assets/images/image/m_menu-football.svg">
                            <p>football</p>
                        </div>
                        <div class="tab-img-div" (click)="confirmSport(2)">
                            <img class="img-fluid" src="assets/images/image/m_menu-tennis.svg">
                            <p>tennis</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="teenpatti-tab" role="tabpanel" aria-labelledby="v-teenpatti-tab">
                        <div class="tab-img-div" (click)="confirmSport(99999)">
                            <img class="img-fluid" src="assets/images/image/m_menu-teenpatti.svg">
                            <p>teenpatti</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="casino-tab" role="tabpanel" aria-labelledby="v-casino-tab">
                        <div class="tab-img-div" (click)="confirmSport(99995)">
                            <img class="img-fluid" src="assets/images/image/m_menu-casino.svg">
                            <p>casino</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="sp-tab" role="tabpanel" aria-labelledby="v-sp-tab">
                        <div class="tab-img-div" (click)="confirmSport(99990)">
                            <img class="img-fluid" src="assets/images/image/m_menu-binary.svg">
                            <p>binary</p>
                        </div>
                        <div class="tab-img-div" (click)="confirmSport(2378961)">
                            <img class="img-fluid" src="assets/images/image/m_menu-election.svg">
                            <p>election</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- for mobile view -->

    <!-- casino -->
    <section id="casino" class="casino py-4">
        <div class="container">
            <h2 class="section-title text-center">casino <small>Now play in the best casinos available! A newer
                    experience</small></h2>
            <div class="row">

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-teenpatti.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/teenpatti_2.png">
                                TeenPatti
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99999, 56767)">TeenPatti</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-casinogames.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/bbb-sport.png">
                                Casino
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99999, 99999)">Casino</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-dragontiger.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/livecasino.png">
                                Baccarat
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99999, 92038)">Baccarat</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-poker.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/jackpot.png">
                                Poker
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99999, 67564)">Poker</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-blackjack.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/spevent.png">
                                Blackjack
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99995, 11022)">Blackjack</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6">
                    <div class="casino-div">
                        <div class="casino-img position-relative">
                            <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-roulette.png">
                            <p>
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/icons/wheel.png">
                                Roulette
                            </p>
                        </div>
                        <div class="casino-content">
                            <div class="casino-content-back position-relative">
                                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/flip-flag.png">
                                <p>
                                    <a href="javascript:void(0)" (click)="confirmLogin(99999, 98788)">Roulette</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- casino -->

    <section class="home_live_casino d-none d-sm-block">
        <div class="container px-1">
            <h2 class="inner-title">
                Live Casino
            </h2>
  
            <div class="row">
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 11022)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/36_evo_liveblackjacka.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5002)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/17_evo_supersicbo.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5003)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/18_evo_dragontiger.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5004)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/19_evo_livespeedbaccarata.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5015)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/30_evo_livebaccarata.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5006)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/21_evo_livespeedbaccaratc.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5018)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/33_evo_livebaccaratsqueeze.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 11022)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/39_evo_infiniteblackjack.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5261)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/276_ezg_baccaratsuper6.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5263)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/278_ezg_dragontiger.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5232)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/247_ezg_cumbiaruleta1.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5247)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/262_ezg_casinoholdem.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5272)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/362_bgt_diceduel.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5248)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/263_teen_patti_227100.png" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6" (click)="confirmLogin(99995, 5271)">
                    <!-- small box -->
                    <div class="small-box position-relative">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/361_bgt_lucky7.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <!-- small box -->
                    <div class="small-box position-relative" (click)="confirmLogin(99995, 5275)">
                        <img src="http://speedcdn.io/assets/kesar-client/landing/casino/365_bgt_wheeloffortune.jpg" width="100%" style="max-height: 150px;" class="img-thumbnail" />
                    </div>
                </div>
                <!-- ./col -->
  
                <!-- ./col -->
            </div>
        </div>
    </section>

    <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <h2 class="inner-title">
                <i class="icofont-star-alt-1"></i>
                <i class="icofont-penalty-card"></i>
                 Live Cards 
                <i class="icofont-star-alt-1"></i>
                <i class="icofont-penalty-card"></i>
            </h2>
  
            <div class="row">
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56767)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/liveteenpatti.jpg">
                        <p>live teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56768)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattit20.jpg">
                        <p>teenpattit20</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67600)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/muflis_teenpatti.jpg">
                        <p>muflis teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67630)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpatti_test.jpg">
                        <p>teenpatti test</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67660)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/2cards_teenpatti.jpg">
                        <p>2cards teenpatti</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67567)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/2020poker.jpg">
                        <p>2020poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 87564)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/andarbahar1.jpg">
                        <p>andar-bahar </p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56967)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/32casino.jpg">
                        <p>32casino</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56968)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/hi-low.jpg">
                        <p>hi-low</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98788)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/roullete.jpg">
                        <p>roullete</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98566)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/sicbo.jpg">
                        <p>sicbo</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98791)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/aaa.jpg">
                        <p>Amar Akbar Anthony</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67580)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/casinowar.jpg">
                        <p>casinowar</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67620)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/queen_race.jpg">
                        <p>queen race</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67680)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/trap.jpg">
                        <p>trap</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67610)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/trio.jpg">
                        <p>trio</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 92038)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/baccarat.jpg">
                        <p>baccarat</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67575)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/casino_meter.jpg">
                        <p>casino meter</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67570)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/bollywood.jpg">
                        <p>bollywood</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 90100)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/race_2020.jpg">
                        <p>race 2020</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 92037)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/matka.jpg">
                        <p>matka</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/6poker.jpg">
                        <p>6-player poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98790)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/dragontiger.jpg">
                        <p>dragon-tiger</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67564)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/poker.jpg">
                        <p>poker</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98789)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/7updown.jpg">
                        <p>7updown</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98793)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/7upvirtual.jpg">
                        <p>7updown (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56766)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattivirtual.jpg">
                        <p>teenpatti (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56769)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/teenpattit20virtual.jpg">
                        <p>teenpattit20 (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56966)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/32casinovirtual.jpg">
                        <p>32casino (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 56969)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/hilowvirtual.jpg">
                        <p>hi-low (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67563)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/pokervirtual.jpg">
                        <p>poker (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 87565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/andarbahar1.jpg">
                        <p>andar-bahar</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98792)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/roulletevirtual.jpg">
                        <p>roullete (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 92036)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/matkavirtual.jpg">
                        <p>matka (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 98795)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/aaavirtual.jpg">
                        <p>Amar Akbar Anthony (virtual)</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="confirmLogin(99999, 67565)">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/casino/sixplayerpoker.jpg">
                        <p>sixplayerpoker</p>
                    </div>
                </div>
              </div>
        </div>
    </section>

    <section class="home_live_casino d-block d-sm-none">
        <div class="container px-1">
            <h2 class="inner-title">
                <i class="icofont-star-alt-1"></i>
                <i class="icofont-penalty-card"></i>
                 Casino 
                <i class="icofont-star-alt-1"></i>
                <i class="icofont-penalty-card"></i>
            </h2>
  
            <div class="row">
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:evolution-gaming')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_evolution.png">
                        <p>evolution</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:ezugi')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_ezugib.png">
                        <p>ezugi</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:bombay-live')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_bombay_live.png">
                        <p>bombay live</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:betgamestv')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_betgamesb.png">
                        <p>betgames</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:gamzix')">
                        <img class="img-thumbnail" src="http://speedcdn.io/assets/kesar-client/landing/pr_gamezix.png">
                        <p>gamezix</p>
                    </div>
                </div>
                <!-- <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:betsoft')">
                        <img class="img-thumbnail" src="assets/images/gstatic/bet_soft.png">
                        <p>bet soft</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:caleta-gaming')">
                        <img class="img-thumbnail" src="assets/images/gstatic/caleta_gaming.png">
                        <p>caleta gaming</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:golden-rock-studios')">
                        <img class="img-thumbnail" src="assets/images/gstatic/golden_rock.png">
                        <p>golden rock</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:green-jade')">
                        <img class="img-thumbnail" src="assets/images/gstatic/green_jade.png">
                        <p>green jade</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:hacksaw-gaming')">
                        <img class="img-thumbnail" src="assets/images/gstatic/hacksaw_gaming.png">
                        <p>hacksaw gaming</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:kalamba-games')">
                        <img class="img-thumbnail" src="assets/images/gstatic/kalamba_games.png">
                        <p>kalamba games</p>
                    </div>
                </div>
                <div class="col-lg-2 col-6">
                    <div class="small-box position-relative" (click)="redirectCasino('99995:turbogames')">
                        <img class="img-thumbnail" src="assets/images/gstatic/turbo_games.png">
                        <p>turbo games</p>
                    </div>
                </div> -->
            </div>
        </div>
    </section>

    <!-- betting experience -->
    <section id="betting-experience" class="py-4">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/bg-mobile.png">
                </div>

                <div class="col-md-6">
                    <div class="nbe-content">
                        <h2>Experience The Future Of Sports!</h2>
                        <h3>Now Get Your Betting ID Faster Than Your 2 Minutes Noodles.</h3>
                        <button class="exch-btn">exchange</button>
                        <button class="fo-btn">fixed odds</button>
                        <p>Start online betting with {{env.host.domain}} and enjoy 
                            cricket betting as well as your other favorite sports like football, Tennis, and Horse-racing. Simply create your online Cricket ID and Sports ID and take advantage of our best offers. You can also play number of online casino with a variety of games such as Teen Patti, Poker, Andar-Bahar, and more. Benefit from the Best option on all your favourite sports and Games. Get the best returns on your bets here!</p>
                        <p>online cricket id, best online cricket id, cricket id provide, online cricket id, cricket betting, betting ID, cricket id online, online id cricket, cricket online id, online cricket betting id</p>
                        <!-- <div class="media align-items-center text-uppercase">
                            <img class="img-fluid align-self-center mr-2" src="assets/images/image/download_apps.png">
                            <h4>SCAN QRCODE TO DOWNLOAD APP <small>Support Android & IOS devices.</small></h4>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- betting experience -->

    <!-- <section class="celebs_section">
        <div class="container">
            <h2>CELEBS LOVE US</h2>
            <swiper [config]="swiperConfig">
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ADHYAYAN SUMAN</h6>
                        <img class="img-fluid" src="assets/images/celebs/s9.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '9')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>RUSHAD RANA</h6>
                        <img class="img-fluid" src="assets/images/celebs/s10.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '10')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ROOPAL TYAGI</h6>
                        <img class="img-fluid" src="assets/images/celebs/s11.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '11')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>FALAQ NAAZ</h6>
                        <img class="img-fluid" src="assets/images/celebs/s12.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '12')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SNEHA ULLAL</h6>
                        <img class="img-fluid" src="assets/images/celebs/s13.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '13')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KARAN PATEL</h6>
                        <img class="img-fluid" src="assets/images/celebs/s14.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '14')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>DAISY SHAH</h6>
                        <img class="img-fluid" src="assets/images/celebs/s15.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '15')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SHAMITA SHETTY</h6>
                        <img class="img-fluid" src="assets/images/celebs/s16.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '16')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SAPNA CHOUDHARY</h6>
                        <img class="img-fluid" src="assets/images/celebs/s17.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '17')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>HINA KHAN</h6>
                        <img class="img-fluid" src="assets/images/celebs/s18.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '18')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KAINAAT ARORA</h6>
                        <img class="img-fluid" src="assets/images/celebs/s19.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '19')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>SHAKTI KAPOOR</h6>
                        <img class="img-fluid" src="assets/images/celebs/s1.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '1')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>KARISHMA TANNA</h6>
                        <img class="img-fluid" src="assets/images/celebs/s2.webp">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '2')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>MADALSA SHARMA</h6>
                        <img class="img-fluid" src="assets/images/celebs/s3.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '3')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>ZOYA AFROZ</h6>
                        <img class="img-fluid" src="assets/images/celebs/s4.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '4')"></div>
                  </div>
                </ng-template>
                <ng-template swiperSlide>
                  <div class="slide-content">
                        <h6>DEEPSHIKHA NAGPAL</h6>
                        <img class="img-fluid" src="assets/images/celebs/s6.png">
                        <div [ngClass]="env.isMobile ? 'play-button1' : 'play-button'" (click)="playvideo(celebModal, '6')"></div>
                  </div>
                </ng-template>
              </swiper>

              <div class="celebs_content my-2">
                <h3><b>Online Betting Site {{env.host.name}}</b></h3>
                <p>Welcome to one of the top betting sites in India. Your search for a good online betting site ends here. Get your online betting id or online bookie id on {{env.host.name}} and start playing your favorite online betting games. </p>
              </div>
          </div>
    </section> -->
</main>
<!-- End #main -->


<!-- Modal -->
<!-- <ng-template #celebModal>
    <div class="modal-header">
      <h4 class="modal-title pull-left" id="vidtitle">Celebs Name</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="stopvideo()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body" id="datacelb">
    </div>
</ng-template> -->
<!-- Modal -->

<!-- mobile footer -->
<app-footer></app-footer> <!-- mobile footer -->

<app-sidebar></app-sidebar>

<footer id="footer" class="footer">
    <div class="container">
        <div class="row">
            <div class="col-md-3">
                <img class="img-fluid" src="assets/images/{{env.host.name}}/footer-logo.png" style="margin: 15px 0; width: 200px;" />
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/ssl.png" style="max-width: 100px;" />&nbsp;
                <a href="javascript:void(0)" class="text-white">
                    <strong>100% SAFE</strong><br />
                    Protected connection and encrypted data.
                </a>
            </div>

            <div class="col-md-3 pt-4">
                <h5><span> Payment Methods </span></h5>
                <div class="row d-none d-sm-flex">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phonepe_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank_b.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
                <div class="row d-sm-none d-inline-flex m-0">
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/bhim.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/upi.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0"><img src="http://speedcdn.io/assets/kesar-client/landing/phone_pay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/paytm.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/gpay.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                    <div class="col-4 p-0 mt-3"><img src="http://speedcdn.io/assets/kesar-client/landing/bank.png" style="opacity: unset; background: none;" class="img-thumbnail" /></div>
                </div>
            </div>

            <div class="col-md-2 pt-4">
                <h5><span> Menu </span></h5>
                <a href="javascript:void(0)" class="text-white">About Us</a><br />
                <a href="javascript:void(0)" class="text-white">Rules</a><br />
                <a href="javascript:void(0)" class="text-white">Terms &amp; Conditions</a><br />
                <a href="javascript:void(0)" class="text-white">Responsible Gaming</a>
            </div>

            <div class="col-md-2 pt-4">
                <h5><span> Game Therapy </span></h5>
                <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/18-plus-color-footer.png" data-toggle="modal" data-target="#modal_18rules" style="cursor: pointer;" />
                <a href="https://www.gamcare.org.uk/" target="_blank"><img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/gamecare.png" /></a>
                <a href="https://www.gamblingtherapy.org/en" target="_blank"> <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/gt.png" /></a>

                <div style="align-items: center;">
                    <strong class="text-white"> Chat With Us : </strong><a *ngIf="env.host.whatsapp != ''" [href]="env.host.whatsapp" target="_blank"> <img class="img-fluid" src="http://speedcdn.io/assets/kesar-client/landing/chat.png" /> </a>
                </div>
            </div>

            <div class="col-md-2 pt-4" style="font-size: 12px; color: #fff;">
                <h5><span> Follow Us </span></h5>

                <a *ngIf="env.host.facebook != ''" [href]="env.host.facebook" target="_blank"><img src="http://speedcdn.io/assets/kesar-client/landing/facebook.png" /></a>
                <a *ngIf="env.host.whatsapp != ''" [href]="env.host.whatsapp" target="_blank"><img src="http://speedcdn.io/assets/kesar-client/landing/whatsapp.png" /></a>
                <a *ngIf="env.host.telegram != ''" [href]="env.host.telegram" target="_blank"><img src="http://speedcdn.io/assets/kesar-client/landing/telegram.png" /></a>
                <a *ngIf="env.host.instagram != ''" [href]="env.host.instagram" target="_blank"><img src="http://speedcdn.io/assets/kesar-client/landing/instagram.png" /></a>
                <a *ngIf="env.host.youtube != ''" [href]="env.host.youtube" target="_blank"><img src="http://speedcdn.io/assets/kesar-client/landing/youtube.png" /></a><br />
                <div class="mt-1">
                    <span class="support">
                        Support:
                        <hr> 
                        <a href="https://web.whatsapp.com/send?phone={{env.host.contactNo}}" target="_blank" style="color: #fff;">+{{env.host.contactNo}}</a> <br />
                        <!-- <a href="https://web.whatsapp.com/send?phone=7599999125" target="_blank" style="color: #fff;">+91 7599999125</a> /<br />
                        <a href="https://web.whatsapp.com/send?phone=7599999125" target="_blank" style="color: #fff;">+91 7599999125</a> -->
                    </span>
                </div>
                <div class="mt-1">
                    <span class="support"> <a href="mailto:{{env.host.email}}" style="color: #fff;">{{env.host.email}}</a></span>
                </div>
                <!-- <div class="d-qr-none"><img class="img-thumbnail" src="assets/images/footer/scan_me.jpeg" /></div> -->
            </div>
        </div>

        <p style="align-items: center;">
            The website is operated by {{env.host.name}} N.V. registered in Curaçao under the registration number 159415, with address at Zuikertuintjeweg Z/N (Zuikertuin Tower) , Curaçao. The transactions are processed by {{env.host.name}} N.V. which owns
            and operates the website {{env.host.domain}}.
        </p>

        <p style="align-items: center;">© Copyright 2020-2021 {{env.host.name}}. All rights reserved</p>
    </div>
</footer>